var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-component',_vm._b({style:(_vm.containerStyle),attrs:{"link":_vm.component.link}},'cms-component',_vm.$props,false),[_c('b-img',{staticClass:"image-component",style:(_vm.imageStyle),attrs:{"src":_vm.imageSrc,"blank":!_vm.imageSrc,"blank-color":"#ddd","alt":_vm.altText},on:{"error":function($event){_vm.useFallback = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }